import styled from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'

const StContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  grid-template-areas:
    'content'
    'button';
`

const StEmptyIconContainer = styled.div`
  width: 136px;
  height: 165px;
`

const StCard = styled(Flex)`
  ${({ theme }) => `
    background-color: ${theme.Components.Card.Fill};
    border: 1px solid ${theme.Components.Card.Border};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    padding: ${theme.UI.SpacingPx.Space6};
    gap: ${theme.UI.SpacingPx.Space5};
    position: relative;
  `}
`

const StIconContainer = styled.div`
  align-items: center;
  height: 100px;

  & > img {
    height: 100%;
  }
`

const StChevron = styled.div`
  ${({ theme }) => `
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: ${theme.UI.SpacingPx.Space6};
    right: ${theme.UI.SpacingPx.Space6};
  `}
`

export { StCard, StChevron, StContainer, StEmptyIconContainer, StIconContainer }
